import React from 'react';

import {lowerizeFirstLetter} from '../../string-utils';
import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
	name: string;
};

// {@monster monster-id, Термин на русском}
export const MonsterPlugin: React.FC<Props> = ({args}) => {
	const [id, title] = args;
	return (
		<Link
			route={'monster'}
			params={{id}}
			title={title}
			className={linkClass('monster')}
			data-anchor-type={'monster'}
			data-anchor-id={id}
		>
			{title}
		</Link>
	);
};
